ux-iws-back-teaser {
    display: block;
}
